import type { FlightSearchState } from '../flightDefaultState';

export const buildFlightTrackingItem = (form: FlightSearchState) => {
    return {
        id: 'finntravel',
        type: 'Travel',
        destination: form.destinationCountry,
        arrivalCity: form.destinationCity,
        arrivalAirport: form.destination,
        departureCountry: form.originCountry,
        departureCity: form.originCity,
        departureAirport: form.origin,
        travelType: 'flight',
        tripType: form.tripType,
        departureDate: form.departureDate?.toISOString(),
        returnDate: form.returnDate?.toISOString(),
        numberOfAdults: form.adults,
        numberOfChildren: form.children + form.infants,
        cabin: form.cabinType,
    };
};
